import { maintenanceClient } from '../../api/clients';
import checkMaintenance from './check-maintenance-service';

const maintenanceService = {
  checkMaintenance: checkMaintenance(maintenanceClient),
};

export default maintenanceService;
